const KEY = 'migrationIgnoreUntil';

export function markMigrationIgnored(ms = 20000): void {
  try {
    sessionStorage.setItem(KEY, String(Date.now() + ms));
  } catch (e) { /* ignore */ }
}

export function isMigrationIgnored(): boolean {
  try {
    return Number(sessionStorage.getItem(KEY) || 0) > Date.now();
  } catch (e) {
    return false;
  }
}
